import * as React from "react";
import { Helmet } from "react-helmet";
import { withPrefix } from "gatsby";
//import { MDXrenderer } from 'gatsby-plugin-mdx'
// import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax'
import Hero from "./../components/hero/hero";
import HeroQuote from "./../components/hero/hero-quote";
import HeroVideos from "./../components/hero/hero-videos";
import Region from "./../components/regions/regional-overview-sp.js";
import Title from "./../components/title/title";
import Interactive from "./../components/graphics/interactive";
import Zoomable from "./../components/graphics/zoomable";
import SelectReport from "./../components/downloads/selection-sp";
import YouTubeVideo from "../components/video/embed-video";
import ShowModal from "../components/modal/modal-sp";
import ShowModalInfog from "../components/modal/modalinfographic.js";
import DownloadPub from "../components/downloads/publications-sp";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import "./../style.scss";
// import AppBarNoMenu from './../components/appbarextended/appbarwithoutmenu'
// import ExtendedCountdown from './../components/countdown/extendedcountdown'
// import { darkBlue } from './../assets/scss/variables.module.scss'
//import AppBarMenu from './../components/appbarextended/appbarwithmenu'
import logo from "./../images/IDMC_logo_white.svg";
//import socialmediaimage from './../images/grid2022_cover.jpg'
import JSONData from "./../content/jsonfile-sp.json";
// import VisibilitySensor from 'react-visibility-sensor'
import Footer from "../components/hero/footer-sp";
import PictureAsPdfIconOutlined from "@mui/icons-material/PictureAsPdfOutlined";

// import coverImage from 'https://www.internal-displacement.org/sites/default/files/GRID22_cover_img_edited%202.jpg'
// import scrollTo from 'gatsby-plugin-smoothscroll'
import Fade from "react-reveal/Fade";
// import { StaticImage } from 'gatsby-plugin-image'
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

// import GlobalMap from './../images/svg/globalmap2021.svg'
//G6_ND_25_2021RGB2Spiral-01
import Spiral from "./../images/svg/G6_ND_25_2021RGB2Spiral-01 - Copy-sp.svg";
import SpiralMobile from "./../images/mobile_png/IDMC_GRID_2022 Los veinticinco países con más desplazamientos internos en 2021.jpg";
import SpiralDld from "./../images/downloadable/GRID22-25-countries-es.png";

// import Breakdown from './../images/svg/G7_ND_Breadown_ConflictDisastersRGB copy.svg'
import BreakdownMobile from "./../images/mobile_png/IDMC_GRID_2022 Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021 v.jpg";
import BreakdownMobilePortrait from "./../images/mobile_png/IDMC_GRID_2022 Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021 h.jpg";
import BreakddownDld from "./../images/downloadable/GRID22-breakdown-es.png";

// import Age from './../images/mobile_png/G4_IDPS_Globally_2020 age groupRGB.jpg'
//G6_ND_25_2021RGB2Spiral
//import Globe_Ssa from './../images/svg/globes/displacements-region-pie-sub_saharan_africa.svg'
import Quote1 from "./../images/background-images/P1_Foreword_CMYK_Iraq.jpg";
import Quote2 from "./../images/background-images/P9-10_740A1478.jpg";
import Quote3 from "./../images/background-images/P49-50_GettyImages-1233122089.jpg";
import Quote4 from "./../images/background-images/P53_UN0570020.jpg";
//import Quote5 from './../images/background-images/P86_GettyImages-1371333006.jpg'
import Quote6 from "./../images/background-images/P118_740A2125_edited.jpg";
import Quote7 from "./../images/background-images/GettyImages-1236933621.jpg";
import Quote8 from "./../images/background-images/P87-88_GettyImages-1234025493.jpg";

import Alexandra from "./../images/spokespeople/Alexandra.jpg";
import Jan from "./../images/spokespeople/Jan.jpg";
import Bina from "./../images/spokespeople/Bina.jpg";
import Vicente from "./../images/spokespeople/Vicente.jpg";
import Vincent from "./../images/spokespeople/Vincent.jpg";
import Ivana from "./../images/spokespeople/Ivana.jpg";
import Ricardo from "./../images/spokespeople/Ricardo.jpg";

import globe_am from "./../images/svg/globes/G1_ND_A_PerRegion_ConflictDisasters.CMYK.png";
import globe_eap from "./../images/svg/globes/G1_ND_EAP_PerRegion_ConflictDisasters6RGB.png";
import globe_eca from "./../images/svg/globes/G1_ND_ECA_PerRegion_ConflictDisasters5RGB.png";
import globe_mena from "./../images/svg/globes/G1_ND_MENA_PerRegion_ConflictDisasters4RGB.png";
import globe_sa from "./../images/svg/globes/G1_ND_SA_PerRegion_ConflictDisasters3RGB.png";
import globe_ssa from "./../images/svg/globes/G1_ND_SSA_PerRegion_ConflictDisasters2RGB.png";

import map_global_svg from "./../images/svg/globalmap2022-2-01-sp.svg";
import map_global from "./../images/mobile_png/IDMC_GRID_2022 Desplazamiento interno por conflicto y desastres en 2021.jpg";
import map_global_dld from "./../images/downloadable/GRID22-global-map-es.png";
import map_conflict_svg from "./../images/svg/GRID2022 Stock Conflict RGBlight - Simplify-01-sp.svg";
import map_conflict from "./../images/mobile_png/IDMC_GRID_2022 Número total de desplazados internos por conflicto y violencia a 31 de diciembre de 2021.jpg";
import map_conflict_dld from "./../images/downloadable/GRID22-map-conflict-es.png";
import map_disasters_svg from "./../images/svg/GRID2022 Stock Disasters RGBlight - Simplify-01-sp.svg";
import map_disasters from "./../images/mobile_png/IDMC_GRID_2022 Número total de desplazados internos por desastres a 31 de diciembre de 2021.jpg";
import map_disasters_dld from "./../images/downloadable/GRID22-map-disasters-es.png";
import map_youth_svg from "./../images/svg/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01-sp.svg";
import map_youth from "./../images/mobile_png/IDMC_GRID_2022 Número total de niños desplazados internos por conflicto, violencia y desastres a 31 de diciembre de 2021.jpg";
import map_youth_dld from "./../images/downloadable/GRID22-map-youth-es.png";
import read_data_conflict from './../images/downloadable/GRID22-how-to-read-data-conflict-es.png'
import read_data_disasters from './../images/downloadable/GRID22-how-to-read-data-disasters-es.png'

import glance_idp from "./../images/mobile_png/IDMC_GRID_2022 Un primer vistazo-Número total de desplazados internos.jpg";
import glance_internaldisplacement from "./../images/mobile_png/IDMC_GRID_2022 Un primer vistazo-Desplazamientos internos en 2021.jpg";
import glance_internaldisplacement_graph from "./../images/mobile_png/IDMC_GRID_2022 Desplazamientos internos en 2021.jpg";
import glance_totalidp_graph from "./../images/mobile_png/IDMC_GRID_2022 Número total de desplazados internos.jpg";

import cover3d from "./../images/grid2022-cover3d.png";

import gridhero from "./../images/grid2022_hero.jpg";
// import img_specialfeature from './../images/P91_DMA10818-comp.jpg'
import ShowModalGlance from "../components/modal/modalglance";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
//import ScrollSpy from 'react-ui-scrollspy'
import PubData from "./../content/json-publicationslinks-sp.json";
// import {BrowserRouter as Router} from 'react-router-dom';
// import { useSearchParams } from "react-router-dom";

// markup
const IndexPageDev = ({ data }) => {
  // const read_data_conflict =
  //   "./../images/downloadable/GRID22-how-to-read-data-conflict-es.png";
  // const read_data_disasters =
  //   "./../images/downloadable/GRID22-how-to-read-data-disasters-es.png";
  //const banner =
  //   'https://www.internal-displacement.org/sites/default/files/2022-04/idmc_grid22_cover_website_150dpi.jpg'

  const countrylistoptions = [];
  const countrylist = [
    "AFG",
    "ARM",
    "AZE",
    "BGD",
    "BIH",
    "BRA",
    "BFA",
    "BDI",
    "KHM",
    "CMR",
    "CAF",
    "TCD",
    "CHL",
    "CHN",
    "COL",
    "CYP",
    "COD",
    "ECU",
    "ETH",
    "GEO",
    "GTM",
    "HTI",
    "HND",
    "IND",
    "IDN",
    "IRQ",
    "ISR",
    "JPN",
    "LBY",
    "MDG",
    "MYS",
    "MLI",
    "MEX",
    "MOZ",
    "MMR",
    "NPL",
    "NER",
    "NGA",
    "PAK",
    "PSE",
    "PNG",
    "PHL",
    "SLV",
    "SOM",
    "SSD",
    "LKA",
    "SDN",
    "SYR",
    "TUR",
    "UGA",
    "UKR",
    "VNM",
    "YEM",
  ];

  countrylist.forEach((element, index) => {
    countrylistoptions.push({
      label: `${PubData[element][0]}`,
      value: `${element}`,
    });
  });

  return (
    <>
      <main>
        <Helmet
          bodyAttributes={{
            "data-bs-spy": "scroll",
            "data-bs-target": "navbarIDMC",
            "data-bs-offset": "150",
          }}
        >
          <meta charSet="utf-8" />
          <title>
            IDMC | GRID 2022 | 2022 Global Report on Internal Displacement
          </title>
          <meta
            name="description"
            content="The world’s leading source of data and analysis on the risk, scale and impacts of internal displacement"
          />{" "}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@IDMC_Geneva" />
          <meta
            name="twitter:title"
            content="2022 Global Report on Internal Displacement"
          />
          <meta
            name="twitter:image"
            content="https://www.internal-displacement.org/sites/default/files/styles/social_media_style/public/2022-05/grid2022_cover.jpg?itok=ui5O8tmW"
          />
          <meta
            property="og:title"
            content="2022 Global Report on Internal Displacement"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:image"
            content="https://www.internal-displacement.org/sites/default/files/2022-05/grid2022_cover.jpg"
          />
          {/* <link
            rel='canonical'
            href='https://internal-displacement.org/global-report/grid2022/'
          /> */}
          <script
            src={withPrefix("tooltip-sp.js?v0.0.1")}
            type="text/javascript"
            defer
          />
          {/* <script src={withPrefix('scrollspy.js')} type='text/javascript' /> */}
        </Helmet>

        <title>IDMC | GRID 2022 </title>
        {/* <AppBarMenu /> */}
        <div>
          <Hero
            imageUrl={gridhero}
            id="hero2"
            txtColor="#ffffff"
            bgColor="#0a3758"
            bgOpacity="0.3"
            copyright="© Ilustración de Matt Murphy, Abril 2022"
          >
            <Container maxWidth="sm">
              <img src={logo} width="199px" alt="IDMC logo" />
              <h1 className="mt-5">
                Informe Mundial sobre Desplazamiento Interno de 2022
              </h1>
              <p>
                El Informe Mundial sobre Desplazamiento Interno (GRID) del IDMC
                es la principal fuente mundial de datos y análisis sobre
                desplazamiento interno. La edición de este año se centra
                especialmente en los niños y jóvenes que viven en situación de
                desplazamiento interno.
              </p>
              <p>
                <a href="#part1" className="whitetext">
                  La 1.ª parte
                </a>{" "}
                presenta datos y análisis actualizados del desplazamiento
                interno a escala global. Perspectivas regionales y enfoques por país incluyen cifras y análisis contextual.
              </p>
              <p>
                <a href="#part2" className="whitetext">
                  La 2.ª parte
                </a>{" "}
                explora las repercusiones del desplazamiento en niños, niñas y jóvenes, quienes a menudo son invisibles en los datos sobre desplazamiento, y destaca las iniciativas prometedoras para abordar algunos de sus retos.
              </p>
            </Container>
          </Hero>
          <nav
            className="navbar navbar-expand-lg navbar-dark fixed-top pt-0"
            id="navbarIDMC"
            style={{ flexDirection: "column" }}
          >
            <div
              className="container-fluid mb-2"
              style={{ background: "#008dc9" }}
            >
              <div
                className="container"
                style={{ justifyContent: "center", display: "flex" }}
              >
                <a
                  className="nav-link"
                  href="https://www.internal-displacement.org/global-report/"
                >
                  Ediciones anteriores
                </a> {" "} <a
                  className="nav-link"
                  href={withPrefix("")}
                >
                  English
                </a>{" "}  <a
                  className="nav-link"
                  href={withPrefix("french")}
                >
                  Français
                </a>{" "}  <a
                  className="nav-link"
                  href="https://www.internal-displacement.org/sites/default/files/2022-10/IDMC_GRID%202022_AR_LowRes.pdf" style={{direction:"rtl"}}
                >
                  العربية 
                </a>
              </div>
            </div>
            <div className="container">
              <a
                className="navbar-brand"
                href="https://www.internal-displacement.org"
              >
                &lt; Volver a la web del IDMC
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="nav navbar-nav me-auto ms-lg-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link" href="#at-a-glance">
                      Un primer vistazo
                    </a>
                  </li>
                  {/* <li className="nav-item">
          <a className="nav-link" href="#">Link</a>
        </li> */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#part1"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      1.ª parte: La situación global
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <li>
                        <a className="dropdown-item" href="#part1">
                          1.ª parte: La situación global
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#spiral">
                          Los veinticinco países con más desplazamientos
                          internos
                        </a>
                      </li>
                      {/* <li><hr className="dropdown-divider" /></li> */}
                      <li>
                        <a className="dropdown-item" href="#breakdown">
                          Desglose por conflicto y desastre
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#people-living-in-displacement"
                        >
                          Personas en situación de desplazamiento
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#regional-overviews">
                          Panoramas regionales
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#part2">
                      2.ª parte: Niños y jóvenes
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link border rounded p-2" href="#download">
                      Descargar el informe
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#mediapack">
                      Dosier de prensa
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <div>
            <Fade>
              <Container maxWidth="lg" id="at-a-glance">
                <Title h4="Un primer vistazo"></Title>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h4>Desplazamientos internos en 2021 </h4>
                    <img
                      src={glance_internaldisplacement}
                      alt="38 million internal displacement - 14.4m by conflict and violence, 23.7m by disasters"
                      style={{ maxWidth: "400px" }}
                    />
                    <div className="d-none d-lg-block">
                      <ShowModalGlance
                        name="At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)"
                        id="glance_internaldisplacement_graph"
                        img={glance_internaldisplacement_graph}
                      />
                    </div>
                    <div className="d-lg-none">
                      <Zoomable
                        src={glance_internaldisplacement_graph}
                        alt="At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)"
                        caption=""
                        zoom="200"
                        dld={glance_internaldisplacement_graph}
                        interact="Puede interactuar con esta infografía para ver los datos en detalle"
                        download="Descargar Infografía"
                      />
                    </div>
                    <p className="small" style={{ color: "#636363" }}>
                      * Es posible que, debido al redondeo, algunos totales no
                      coincidan con la suma de las cifras por separado.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h4>Número total de desplazados internos </h4>
                    <img
                      src={glance_idp}
                      alt="59.1 million internally displaced people - 53.2m by conflict and violence, 5.9m by disasters"
                      style={{ maxWidth: "400px" }}
                    />{" "}
                    <div className="d-none d-lg-block">
                      <ShowModalGlance
                        name="At a glance - Total number of IDPs worldwide at year end (2012-2021)"
                        id="glance_totalidp_graph"
                        img={glance_totalidp_graph}
                      />
                    </div>
                    <div className="d-lg-none">
                      <Zoomable
                        src={glance_totalidp_graph}
                        alt="At a glance - Total number of IDPs worldwide at year end (2012-2021)"
                        caption=""
                        zoom="200"
                        dld={glance_totalidp_graph}
                        interact="Puede interactuar con esta infografía para ver los datos en detalle"
                        download="Descargar Infografía"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h4>Cómo leer nuestros datos</h4>
                  </div>
                  <div className="col-md-6">
                    <ShowModalGlance
                      name="How to read our data - conflict and violence"
                      id="read_data_conflict"
                      img={read_data_conflict}
                    />
                  </div>
                  <div className="col-md-6">
                    <ShowModalGlance
                      name="How to read our data - disasters"
                      id="read_data_disasters"
                      img={read_data_disasters}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <YouTubeVideo youtubeId="D48t_X3neAY"></YouTubeVideo>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <YouTubeVideo youtubeId="BHRI-0suJhw"></YouTubeVideo>
                  </div>
                </div>
              </Container>
            </Fade>

            <div id="part1" className="section">
              <Fade>
                <Container maxWidth="lg">
                  <Title
                    h2="1.ª parte: la situación global"
                    h3="Desplazamiento interno en 2021"
                  ></Title>
                  <p>
                    El conflicto, la violencia y los desastres provocaron{" "}
                    <strong>38 millones de desplazamientos internos</strong> en
                    141 países y territorios en 2021, la segunda cifra anual más
                    alta de la década después del récord histórico de
                    desplazamiento por desastres en 2020. Los conflictos y la
                    violencia provocaron 14,4 millones de movimientos, lo que
                    supone un aumento de casi un 50 % respecto del año anterior.
                  </p>

                  {/* <Zoomable
                  src={map_global}
                  alt='Countries and territories with most new displacements in 2021'
                  caption='Countries and territories with most new displacements in 2021'
                  zoom='200'
                  dld='/'
                  interact='Puede interactuar con esta infografía para ver los datos en detalle'
                  download='Descargar Infografía'
                /> */}
                </Container>
                <Container>
                  <Interactive
                    svg={map_global_svg}
                    png={map_global}
                    id="globalmap"
                    tooltip_id="globaltooltip"
                    dld={map_global_dld}
                    caption="Países y territorios con más desplazamientos internos en 2021"
                    alt="Países y territorios con más desplazamientos internos en 2021"
                    interact="Puede interactuar con esta infografía para ver los datos en detalle"
                    download="Descargar Infografía"
                    name="Global map"
                    dropdown={[
                      "AFG",
                      "AGO",
                      "AUS",
                      "BGD",
                      "BRA",
                      "BFA",
                      "BDI",
                      "CMR",
                      "CAN",
                      "CAF",
                      "TCD",
                      "CHN",
                      "COL",
                      "CUB",
                      "COD",
                      "SLV",
                      "ETH",
                      "GRC",
                      "HTI",
                      "IND",
                      "IDN",
                      "IRN",
                      "IRQ",
                      "KEN",
                      "KGZ",
                      "MYS",
                      "MLI",
                      "MEX",
                      "MOZ",
                      "MMR",
                      "NPL",
                      "NLD",
                      "NER",
                      "NGA",
                      "PAK",
                      "PSE",
                      "PHL",
                      "SOM",
                      "SSD",
                      "LKA",
                      "VCT",
                      "SDN",
                      "SYR",
                      "TZA",
                      "TUR",
                      "UGA",
                      "USA",
                      "VEN",
                      "VNM",
                      "YEM",
                    ]}
                  />
                </Container>
              </Fade>
              <HeroQuote
                imageUrl={Quote6}
                id="quote-6"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Una niña que actualmente reside en Tillaberi, Níger pudo volver a relacionarse con sus compañeros de clase y amigos después de recibir apoyo psicosocial para ayudarle a gestionar su experiencia de desplazamiento. © Abril 2022 "
              ></HeroQuote>
              <Fade>
                <>
                  <Container maxWidth="lg" id="spiral">
                    <Title h4="Los veinticinco países con más desplazamientos internos"></Title>
                  </Container>{" "}
                  <Container maxWidth="lg">
                    <Interactive
                      svg={Spiral}
                      png={SpiralMobile}
                      id="spiral"
                      tooltip_id="sunbursttooltip"
                      dld={SpiralDld}
                      caption="Los veinticinco países y territorios con más desplazamientos internos en 2021"
                      alt="Los veinticinco países y territorios con más desplazamientos internos en 2021"
                      interact="Puede interactuar con esta infografía para ver los datos en detalle"
                      download="Descargar Infografía"
                      name="Spiral"
                      dropdown={[
                        "AFG",
                        "BFA",
                        "BRA",
                        "CAF",
                        "CHN",
                        "COD",
                        "CUB",
                        "ETH",
                        "HTI",
                        "IDN",
                        "IND",
                        "MLI",
                        "MMR",
                        "MOZ",
                        "NER",
                        "NGA",
                        "PHL",
                        "SDN",
                        "SLV",
                        "SOM",
                        "SSD",
                        "SYR",
                        "USA",
                        "VNM",
                        "YEM",
                      ]}
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote3}
                id="quote-3"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Palestinos desplazados en tiendas instaladas entre los escombros en Gaza. © Mustafa Hassona/Anadolu Agency a través de Getty Image, mayo de 2021."
              ></HeroQuote>
              <Fade>
                <>
                  <Container className="mt-5" maxWidth="lg" id="breakdown">
                    <Title h4="Desglose por conflicto y desastre"></Title>
                  </Container>{" "}
                  <Container className="showLandscape" maxWidth="lg">
                    <Zoomable
                      src={BreakdownMobile}
                      id="breakdowngraphic"
                      tooltip_id=""
                      dld={BreakddownDld}
                      caption="Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021"
                      alt="Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021"
                      interact="Puede interactuar con esta infografía para ver los datos en detalle"
                      download="Descargar Infografía"
                      zoom={200}
                      name="breakdown"
                    />
                  </Container>
                  <Container className="showPortrait" maxWidth="lg">
                    <Zoomable
                      src={BreakdownMobilePortrait}
                      id="breakdownPortrait"
                      tooltip_id=""
                      dld={BreakddownDld}
                      caption="Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021"
                      alt="Desglose de los desplazamientos internos por conflicto, violencia y desastres en 2021"
                      interact="Puede interactuar con esta infografía para ver los datos en detalle"
                      download="Descargar Infografía"
                      zoom={200}
                      name="breakdown"
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote2}
                id="quote-2"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="Campamento de desplazados de Mbela, República Centroafricana. © Tom Peyre-Costa/NRC, febrero de 2021."
              ></HeroQuote>
              <Fade>
                <Container className="mt-5" id="people-living-in-displacement">
                  <Title h4="Personas en situación de desplazamiento"></Title>
                  <p>
                    A finales de 2021, había <strong>59,1 millones</strong> de
                    desplazados internos en todo el mundo,{" "}
                    <span className="orange">
                      53,2 millones debido a conflictos y violencia
                    </span>
                    , y <span className="blue">5,9 millones por desastres</span>
                    .
                  </p>
                </Container>
                {/* <Container className='mt-5'>
                  <h4>Conflict</h4>
                </Container>
                <Container >
                  <Interactive
                    svg={map_conflict_svg}
                    png={map_conflict}
                    id='idpconflict'
                    tooltip_id='conflicttooltip'
                    dld={map_conflict_dld}
                    caption='Total number of IDPs by conflict and violence as of 31 December 2021'
                    alt='Total number of IDPs by conflict and violence as of 31 December 2021'
                    interact='Puede interactuar con esta infografía para ver los datos en detalle'
                    download='Descargar Infografía'
                    name='Map - conflict'
                    dropdown={[
                      "AFG",
                      "BFA",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SYR",
                      "YEM"
                      ]}
                  />
                </Container>
                <Container className='mt-5'>
                  <h4>Disasters</h4>
                </Container>
                <Container className='mb-5'>
                  <Interactive
                    svg={map_disasters_svg}
                    png={map_disasters}
                    id='idpdisasters'
                    tooltip_id='disasterstooltip'
                    dld={map_disasters_dld}
                    caption='People internally displaced by disasters as of 31 December 2021'
                    alt='People internally displaced by disasters as of 31 December 2021'
                    interact='Puede interactuar con esta infografía para ver los datos en detalle'
                    download='Descargar Infografía'
                    name='Map - disasters'
                    dropdown={[
                      "AFG",
                      "CHN",
                      "COD",
                      "ETH",
                      "HTI",
                      "IDN",
                      "MOZ",
                      "NGA",
                      "PHL",
                      "SSD"
                      ]}
                  /> */}
                <Container className="mb-5" id="tabs">
                  <Tabs>
                    <TabList>
                      <Tab>Conflicto y violencia </Tab>
                      <Tab>Desastres </Tab>
                    </TabList>
                    <TabPanel>
                      <Interactive
                        svg={map_conflict_svg}
                        png={map_conflict}
                        id="idpconflict"
                        tooltip_id="conflicttooltip"
                        dld={map_conflict_dld}
                        caption="Total number of IDPs by conflict and violence as of 31 December 2021"
                        alt="Total number of IDPs by conflict and violence as of 31 December 2021"
                        interact="Puede interactuar con esta infografía para ver los datos en detalle"
                        download="Descargar Infografía"
                        name="Map - conflict"
                        dropdown={[
                          "AFG",
                          "BFA",
                          "COD",
                          "COL",
                          "ETH",
                          "NGA",
                          "SDN",
                          "SOM",
                          "SYR",
                          "YEM",
                        ]}
                      />
                    </TabPanel>
                    <TabPanel>
                      <Interactive
                        svg={map_disasters_svg}
                        png={map_disasters}
                        id="idpdisasters"
                        tooltip_id="disasterstooltip"
                        dld={map_disasters_dld}
                        caption="Total number of IDPs by disasters as of 31 December 2021"
                        alt="Total number of IDPs by disasters as of 31 December 2021"
                        interact="Puede interactuar con esta infografía para ver los datos en detalle"
                        download="Descargar Infografía"
                        name="Map - disasters"
                        dropdown={[
                          "AFG",
                          "CHN",
                          "COD",
                          "ETH",
                          "HTI",
                          "IDN",
                          "MOZ",
                          "NGA",
                          "PHL",
                          "SSD",
                        ]}
                      />
                    </TabPanel>
                  </Tabs>
                </Container>
              </Fade>
              {/* <Fade>
              <Container className='mt-5' maxWidth='md' id='impacts'>
                <Title h4='The economic and social impacts of displacement'></Title>
                <p>
                  We estimate that the economic impact of internal displacement
                  worldwide was more than $21 billion in 2021. The figure
                  includes the cost of providing every IDP with support for
                  their housing, education, health and security, and accounts
                  for their loss of income for one year of displacement. It is
                  based on information published in humanitarian response plans
                  and only considers the cost of covering IDPs’ basic needs and
                  immediate losses.
                </p>
                <p>
                  It does not include the economic impacts of displacement on
                  host communities or IDPs in the process of returning. Nor does
                  it account for investments made by governments or development
                  stakeholders to address the longer-term consequences of
                  displacement. Put simply, when it comes to understanding the
                  financial burden of the phenomenon, the figure is just the tip
                  of the iceberg.
                </p>
                <YouTubeVideo youtubeId='KcgYNEpuUV4' />
              </Container>
            </Fade>
            <Fade>
              <Container maxWidth='md' id='age'>
                <Title h4='Breakdown of IDPs by age group'></Title>
                <Zoomable
                  src={Age}
                  alt='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  caption='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  zoom='200'
                  dld='/'
                  interact='Puede interactuar con esta infografía para ver los datos en detalle'
                  download='Descargar Infografía'
                />
              </Container>
            </Fade> */}

              <HeroQuote
                imageUrl={Quote4}
                id="quote-4"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0"
                copyright="El tifón Rai provocó el mayor número de desplazamientos por desastres en 2021. En la foto, un niño sentado entre los escombros de su casa destrozada. © UNICEF/ UN0570020/Hogsholt, diciembre de 2021"
              ></HeroQuote>

              <Container maxWidth="lg" id="regional-overviews">
                <Title h4="Panoramas regionales"></Title>
                <p>
                  El África subsahariana concentró más del 80 % de los
                  desplazamientos internos provocados por los conflictos y la
                  violencia en todo el mundo en 2021. El total de la región
                  superó en 4,7 millones la cifra del año anterior,
                  principalmente por los conflictos en Etiopía, la República
                  Democrática del Congo (RDC), Burkina Faso, Somalia y la
                  República Centroafricana (RCA).
                </p>
                <p>
                  La mayoría de los desplazamientos nuevos y repetidos
                  desencadenados por desastres en 2021 se registraron en las
                  regiones de Asia y Pacífico, que juntas suman alrededor del 80
                  por ciento del total. Los ciclones tropicales, las lluvias
                  monzónicas y las inundaciones afectan a zonas especialmente
                  expuestas en las que viven millones de personas. Los países
                  más afectados fueron China, Filipinas e India.
                </p>

                <Region
                  Json={JSONData}
                  regionId="ssa"
                  svg={globe_ssa}
                  hidden={[
                    "Los desastres provocaron 2,6 millones de desplazamientos, un número inferior al de 2020. Las inundaciones fueron menos intensas y generalizadas, y representaron en torno al 60 % del total, frente al 98 % del año anterior. La actividad volcánica, la sequía, las tormentas, los terremotos y los incendios forestales representaron el 40 % restante. Algunos desastres desplazaron a personas en zonas que ya sufrían las repercusiones de los conflictos y la violencia, y la conjunción de estas crisis expuso a millones de personas a una grave inseguridad alimentaria. Numerosos países registraron los peores niveles de su historia, con condiciones de hambruna.",
                    "A finales de año había 27,2 millones de personas en situación de desplazamiento interno en toda la región a causa de conflictos, violencia y desastres, lo que representa un aumento de 3,1 millones respecto a la cifra de 2020. Los desplazados internos fueron objeto de ataques en varios países, que obligaron a algunos a huir de nuevo, lo que empeoró su vulnerabilidad y les impidió el acceso humanitario. Estas preocupantes tendencias nos recuerdan la necesidad urgente de aumentar los esfuerzos para resolver y reducir el desplazamiento interno en la región.",
                    "Una serie de países han adoptado prácticas prometedoras. Entre ellas están la evacuación de personas antes de que se produzcan los desastres y un mejor seguimiento de la duración de los desplazamientos, para ofrecer respuestas más adaptadas a los afectados. También se llevaron a cabo operaciones de retorno dirigidas por el gobierno en al menos cinco países. Sin embargo, estos avances positivos se enfrentan a numerosos retos.",
                  ]}
                >
                  <p>
                    Los conflictos y la violencia provocaron 11,6 millones de
                    desplazamientos internos en África subsahariana en 2021, la
                    cifra más alta registrada en la región hasta el momento. Las
                    nuevas oleadas de violencia en África oriental y la escalada
                    de tensiones y conflictos en las regiones del Sahel central
                    y el lago Chad explicaron la mayor parte de los movimientos,
                    pero la violencia también provocó desplazamientos en África
                    meridional y central, especialmente en RCA, RDC y
                    Mozambique. La actividad militar extranjera también influyó
                    en las tendencias de desplazamiento y retorno en varios
                    países.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="mena"
                  svg={globe_mena}
                  hidden={[
                    "Los desastres también provocaron menos desplazamientos internos en 2021, con 233 000, la cifra más baja desde 2018. Las inundaciones fueron el principal motivo, con 178 000, seguidas de los terremotos y las tormentas. A pesar de todo, la tendencia a cifras más bajas debe interpretarse con prudencia. Ese año, la región se vio afectada por una grave sequía, que provocó escasez de agua e incendios forestales desde Argelia hasta Irán, pero ningún país monitorizó el desplazamiento asociado de manera sistemática, lo que significa que las cifras generales tienden a la baja. A finales de año, había alrededor de 49 000 personas en situación de desplazamiento causado por desastres en toda la región.",
                  ]}
                >
                  <p>
                    Los conflictos y la violencia provocaron un millón de
                    desplazamientos internos en Oriente Medio y el Norte de
                    África (MENA) en 2021, menos de la mitad de los 2,1 millones
                    registrados el año anterior y la cifra más baja de la región
                    en una década. Este descenso se debe, principalmente, a la
                    disminución gradual de los conflictos en Irak, Libia y
                    Siria. Sin embargo, sigue habiendo inestabilidad en estos
                    países, y la violencia aumentó en Yemen. En Gaza también se
                    reanudó el conflicto en mayo, lo que provocó más de 117 000
                    desplazamientos, mientras que la violencia motivó
                    desplazamientos a pequeña escala en Líbano e Israel. En el
                    conjunto de la región, el número de personas en situación de
                    desplazamiento a finales de año por conflicto y violencia se
                    mantuvo prácticamente igual que en 2020, con 12,3 millones.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="eap"
                  svg={globe_eap}
                  hidden={[
                    "Los efectos de La Niña se sufrieron en distintos países por segundo año consecutivo. Las tormentas azotaron el Pacífico Sur y el este y el sureste asiáticos, y desencadenaron más de ocho millones de desplazamientos, la mayoría de ellos como evacuaciones preventivas. Las inundaciones causaron en torno a 5,3 millones. Fueron especialmente intensas en China, donde un episodio de inundación que se produjo en la provincia de Henan en julio provocó alrededor de 1,5 millones de desplazamientos.",
                    "El conflicto y la violencia causaron 626 000 desplazamientos internos en la región, el triple de la cifra de 2020 y la más alta desde 2017. Esto se debe, principalmente, a la intensificación del conflicto en Myanmar, en concreto, tras el golpe militar en febrero. Se registraron en torno a 448 000 desplazamientos, la cifra más alta de la historia del país, pero que sigue siendo un cálculo a la baja. Además, el conflicto se solapó con los desastres, lo que empeoró la situación humanitaria. A finales del año había en torno a 2,8 millones de personas en situación de desplazamiento interno en Asia oriental y el Pacífico, 896 000 de ellos debido al conflicto y la violencia.",
                  ]}
                >
                  <p>
                    Los desastres provocaron 13,7 millones de desplazamientos
                    internos en Asia oriental y el Pacífico en 2021, la cifra
                    más alta desde 2016 y por encima de la media anual de la
                    última década de 11,6 millones. Como en años anteriores, la
                    región contó con la mayor parte de los desplazamientos por
                    desastres registrados en todo el mundo. En esta región se
                    encuentra la mayor parte de la población mundial, que en
                    muchos casos vive en zonas propensas a un gran abanico de
                    amenazas, como tormentas, inundaciones, terremotos y
                    erupciones volcánicas.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="sa"
                  svg={globe_sa}
                  hidden={[
                    "Por su parte, el conflicto y la violencia causaron más de 736 000 desplazamientos, cuya gran mayoría se produjo en Afganistán. Mientras las tropas estadounidenses y de la OTAN iniciaban su retirada final y los talibanes se enfrentaban a las fuerzas gubernamentales, la inseguridad y el deterioro de las condiciones humanitarias provocaron 723 000 desplazamiento, la cifra más alta del país registrada hasta la fecha.",
                    "A finales del año había en torno a 6,9 millones de personas en situación de desplazamiento interno en la región, 5,4 millones por conflicto y violencia y 1,5 millones debido a desastres.",
                  ]}
                >
                  <p>
                    Los desastres son los responsables de la mayor parte de los
                    desplazamientos internos que se producen cada año en Asia
                    meridional, y 2021 no fue una excepción. A lo largo del año
                    se registraron casi 5,3 millones de desplazamientos por
                    desastres, una cifra relativamente alta a escala global,
                    pero inferior a la media de la década en la región, que
                    asciende a 6,2 millones. Este descenso se debe en parte a
                    una temporada de monzones más débil.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="am"
                  svg={globe_am}
                  hidden={[
                    "El conflicto y la violencia desencadenaron 381 000 desplazamientos, la mayoría en Colombia y Centroamérica, y en Haití la recrudescencia de la violencia criminal provocó la cifra más alta registrada. Además, obtuvimos por primera vez datos sobre el desplazamiento debido a la violencia en Brasil, pero como en otras partes de la región, es poco probable que la información recopilada refleje fielmente la realidad, ya que en muchos países tipo de desplazamiento no se contabiliza de forma sistemática.",
                  ]}
                >
                  <p>
                    Los desastres fueron el principal desencadenante de los
                    desplazamientos internos en América en 2021, con casi 1,7
                    millones de personas desplazadas, de las cuales más de la
                    mitad se debieron a tormentas e inundaciones. La región
                    también se vio considerablemente afectada por los incendios
                    forestales y las amenazas geofísicas. La disponibilidad y
                    accesibilidad de los datos varía de forma notable entre los
                    países, lo que influye en las tendencias que veremos a
                    continuación. Los desastres de menor envergadura no se
                    suelen notificar, pero no hay que ignorarlos, ya que tienen
                    repercusiones en las comunidades locales, especialmente en
                    América Latina y el Caribe.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId="eca"
                  svg={globe_eca}
                  hidden={[
                    "La violencia desencadenó al menos 61 000 desplazamientos internos, la cifra más alta de la región desde 2016. Los dos días de enfrentamientos en la frontera de Kirguistán y Tayikistán sumaron 56 000 desplazamientos o, dicho de otra manera, algo más del 90 % del total. En 2021 se registraron muy pocos desplazamientos en Ucrania, pero la ofensiva militar rusa de febrero de 2022 ha hecho que este país se convierta en la mayor situación de desplazamiento interno y de evolución más rápida del mundo.",
                  ]}
                >
                  <p>
                    Los desastres provocaron 276 000 desplazamientos internos en
                    Europa y Asia central en 2021. Los más importantes fueron
                    los incendios forestales en el Mediterráneo, las tormentas e
                    inundaciones en Europa occidental y central y una erupción
                    volcánica en las Islas Canarias, en España.
                  </p>
                </Region>
              </Container>
              {/* <Fade bottom>
              <Container
                className='p-3 mt-5'
                maxWidth={false}
                style={{ backgroundColor: '#dee2e6' }}
              >
                <Container
                  maxWidth='md'
                  id='covid19'
                  className='border p-3 my-5'
                >
                  <Title
                    h3='Special feature'
                    h4='COVID-19: an added burden on the precarious lives of IDPs'
                  ></Title>
                  <div className='row'>
                    <div className='col-md-7'>
                      <p>
                        Covid-19 continued to affect people and economies across
                        the world in 2021 and had negative impacts on IDPs’
                        lives. Comprehensive data is lacking, but several
                        studies and programme insights confirm that the pandemic
                        was uniquely threatening to people on the move. Rather
                        than acting as a leveller, it has aggravated structural
                        inequities and vulnerabilities.
                      </p>
                      <p>
                        It tends to be difficult to disentangle cause and effect
                        and identify whether the pandemic caused, prolonged or
                        worsened a particular crisis. Coming at a time when the
                        world has more IDPs than ever before, however, it has
                        without question made the lives of millions on the move
                        even more precarious. As countries continued lockdown
                        measures and other restrictions to fight the spread of
                        the virus, IDPs felt the consequences on their income,
                        food security, basic services and ability to return to
                        their homes or move onwards to safe havens.
                      </p>
                    </div>
                    <div className='col-md-5'>
                      <img
                        src={img_specialfeature}
                        alt='Young boy wearing a mask'
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>

                  <p>
                    <DownloadPub name='covid' suffix='Download'></DownloadPub>
                  </p>
                </Container>
              </Container>
            </Fade> */}

              <Container maxWidth="lg">
                <p>
                  <DownloadPub name="part1" suffix="Descargar" />
                </p>
              </Container>
              <HeroQuote
                imageUrl={Quote1}
                id="quote-1"
                txtColor="#ffffff"
                bgColor="#0a3758"
                bgOpacity="0.3"
                copyright="Una niña hace un dibujo en un campamento de desplazados en el norte de Irak. © Beate Simarud/NRC, octubre de 2021. "
              >
                <p className="large text-center">
                  «La infancia y la juventud son catalizadores de cambio, Y
                  reconocerlos como tal es fundamental para proteger los avances
                  del desarrollo y reducir el riesgo de futuras crisis. Para
                  construir el mundo del mañana hay que empezar con su
                  participación activa y su liderazgo».
                </p>
                <p>Alexandra Bilak, Director, IDMC</p>
              </HeroQuote>
            </div>
            <>
              <Fade>
                <Container maxWidth="lg" className="section" id="part2">
                  <Title
                    h2="2.ª parte"
                    h3="Niños y jóvenes en desplazamiento interno"
                  ></Title>
                  <p>
                    Aproximadamente 25,2 millones de los desplazados internos de
                    todo el mundo son menores de 18 años, y los efectos de su
                    desplazamiento bien trascienden a su seguridad, bienestar y
                    educación inmediatos. Un niño saludable y feliz presenta más
                    probabilidades de contribuir a una sociedad equitativa y a
                    una economía funcional.
                  </p>
                  <p>
                    Si bien se necesitan más datos para entender mejor estas
                    repercusiones más amplias y a más largo plazo, no cabe duda
                    de que proteger y apoyar a los niños y jóvenes desplazados
                    no solo contribuye a salvaguardar sus derechos, sino también
                    a crear un futuro más estable para todos.
                  </p>
                </Container>
                <Container>
                  <Interactive
                    svg={map_youth_svg}
                    png={map_youth}
                    id="idpyouth"
                    tooltip_id="youthtooltip"
                    dld={map_youth_dld}
                    caption="Número total de niños desplazados internos por conflicto, violencia y desastres a 31 de diciembre de 2021"
                    alt="Número total de niños desplazados internos por conflicto, violencia y desastres a 31 de diciembre de 2021"
                    interact="Puede interactuar con esta infografía para ver los datos en detalle"
                    download="Descargar Infografía"
                    name="Map - youth"
                    dropdown={[
                      "AFG",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SSD",
                      "SYR",
                      "YEM",
                    ]}
                  />
                </Container>
                <Container maxWidth="lg">
                  {/* <Title h4='Key Messages:' />
                <ul>
                  <li>
                    Of the nearly 60 million internally displaced people (IDPs),
                    25.2 million are children under the age of 18.
                  </li>
                  <li>
                    Protecting them from abuse and supporting their health,
                    wellbeing and education not only safeguards their rights,
                    but also contributes to a more stable future for all.
                  </li>
                  <li>
                    Displacement’s impacts on children and youth are not felt
                    equally, and they vary by individual, family and community.
                    Neither are they felt only locally or in the moment, they
                    have wider repercussions for years to come.
                  </li>
                </ul> */}
                  <p>
                    <DownloadPub name="part2" suffix="Descargar" />
                  </p>
                  <Title h4="Conclusión" />
                  <p>
                    El número de personas en situación de desplazamiento interno
                    en todo el mundo ha alcanzado máximos históricos. Las cifras
                    sin precedentes que recoge este informe se deben a tanto a
                    conflictos nuevos como prolongados, especialmente en África
                    y Oriente Medio. Otros varios millones de personas han
                    abandonado sus hogares en Europa en los últimos meses, a
                    medida que la guerra en Ucrania se convierte en la mayor
                    crisis de desplazamiento del mundo. El desplazamiento por
                    desastres sigue representando un reto global considerable,
                    ya que sus repercusiones se notan en todos los rincones el
                    mundo
                  </p>
                  <p>
                    Detrás de los datos hay millones de vidas destruidas,
                    comunidades desgarradas y niños privados de su futuro. Las
                    repercusiones del desplazamiento no solo representan un alto
                    coste para los niños de hoy, sino también para las
                    generaciones venideras. Debemos mirar más allá de las
                    consecuencias directas e inmediatas para los jóvenes si
                    queremos entender mejor su relación con las repercusiones a
                    largo plazo sobre las comunidades y las sociedades. Mientras
                    tanto, reconocer a los niños y a los jóvenes como
                    catalizadores del cambio es fundamental para proteger los
                    avances del desarrollo y reducir el riesgo de futuros
                    desplazamientos.
                  </p>
                  <p>
                    <DownloadPub name="conclusion" suffix="Descargar" />
                  </p>
                </Container>
              </Fade>
              {/* <HeroQuote
                imageUrl={Quote5}
                id='quote-5'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='The owner of the house closest to the Cumbre Vieja Volcano that erupted in La Palma, Canary Islands, Spain in February cleans up the surroundings of his house. © Kike Rincon/Europa Press via Getty Images, February 2022.'
              ></HeroQuote> */}
            </>
            <HeroVideos
              imageUrl={Quote7}
              id="quote-7"
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.8"
              copyright=""
            >
              <Container>
                <Title h4="In their own words"></Title>
                <div className=" row">
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="v4skVdMYBEE" />
                    <p style={{ color: "#ffffff" }}>
                      Jan Egeland, Secretary general, NRC
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="Qj6qmxbci9I" />
                    <p style={{ color: "#ffffff" }}>Christelle Cazabat, IDMC</p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="q3p80WzGero" />
                    <p style={{ color: "#ffffff" }}>
                      Farishta Afzaly, Youth advocate
                    </p>
                  </div>
                </div>
              </Container>
            </HeroVideos>
            <>
              <Container id="download" maxWidth="lg" className="my-3">
                <Title h4="Descargas"></Title>
                <div className="row">
                  <div className="col-md-6">
                    <Fade left>
                      <img src={cover3d} alt="GRID2022 cover" />
                    </Fade>
                  </div>
                  <div className="col-md-6">
                    <Fade right>
                      <p>
                        <DownloadPub name="fullreport"></DownloadPub>
                      </p>
                      <p>
                        <DownloadPub name="fullreporthigh"></DownloadPub>
                      </p>
                      <div className="border p-3 mb-5">
                        <p>O seleccione una sección</p>
                        <SelectReport
                          options={[
                            {
                              label: `${PubData["foreword"][0]}`,
                              value: "foreword",
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: `${PubData["part1"][0]}`,
                              value: "part1",
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: "Panoramas regionales",
                              options: [
                                {
                                  label: `${PubData["ssa"][0]}`,
                                  value: "ssa",
                                },
                                {
                                  label: `${PubData["mena"][0]}`,
                                  value: "mena",
                                },
                                {
                                  label: `${PubData["eap"][0]}`,
                                  value: "eap",
                                },
                                {
                                  label: `${PubData["sa"][0]}`,
                                  value: "sa",
                                },
                                {
                                  label: `${PubData["am"][0]}`,
                                  value: "am",
                                },
                                {
                                  label: `${PubData["eca"][0]}`,
                                  value: "eca",
                                },
                              ],
                            },
                            {
                              label: "Destacados",
                              options: [
                                {
                                  label: `${PubData["ssa-eth"][0]}`,
                                  value: "ssa-eth",
                                },
                                {
                                  label: `${PubData["ssa-sdn"][0]}`,
                                  value: "ssa-sdn",
                                },
                                {
                                  label: `${PubData["mena-pal"][0]}`,
                                  value: "mena-pal",
                                },
                                {
                                  label: `${PubData["eap-chn"][0]}`,
                                  value: "eap-chn",
                                },
                                {
                                  label: `${PubData["eap-mmr"][0]}`,
                                  value: "eap-mmr",
                                },
                                {
                                  label: `${PubData["eap-png"][0]}`,
                                  value: "eap-png",
                                },
                                {
                                  label: `${PubData["sa-afg"][0]}`,
                                  value: "sa-afg",
                                },
                                {
                                  label: `${PubData["am-hai"][0]}`,
                                  value: "am-hai",
                                },
                                {
                                  label: `${PubData["eca-ca"][0]}`,
                                  value: "eca-ca",
                                },
                                {
                                  label: `${PubData["eca-wa"][0]}`,
                                  value: "eca-wa",
                                },
                              ],
                            },
                            {
                              label: "----------------------",
                              value: "",
                              isDisabled: true,
                            },
                            {
                              label: `${PubData["part2"][0]}`,
                              value: "part2",
                            },
                            {
                              label: `${PubData["conclusion"][0]}`,
                              value: "conclusion",
                            },
                            {
                              label: `${PubData["figures"][0]}`,
                              value: "figures",
                            },
                          ]}
                          action="Ver"
                        ></SelectReport>
                      </div>
                      <>
                        <div className="border p-3 mb-5">
                          <p>Documentos de referencia</p>
                          <SelectReport
                            options={[
                              {
                                label: `${PubData["bg-unesco-iiep"][0]}`,
                                value: "bg-unesco-iiep",
                              },
                              {
                                label: `${PubData["bg-save-1"][0]}`,
                                value: "bg-save-1",
                              },
                              {
                                label: `${PubData["bg-save-2"][0]}`,
                                value: "bg-save-2",
                              },
                              {
                                label: `${PubData["bg-plan-int"][0]}`,
                                value: "bg-plan-int",
                              },
                              {
                                label: `${PubData["bg-jips"][0]}`,
                                value: "bg-jips",
                              },
                              {
                                label: `${PubData["bg-iom-unicef"][0]}`,
                                value: "bg-iom-unicef",
                              },
                              {
                                label: `${PubData["bg-impact"][0]}`,
                                value: "bg-impact",
                              },
                            ]}
                            action="Descargar"
                          ></SelectReport>
                        </div>
                      </>
                      <>
                        <p>
                          Cifras por países{" "}
                          <Tooltip title="Information on the sources of our figures, as well as methodologies and caveats for some of the countries most affected by internal displacement. For any additional information contact us at info@idmc.ch">
                            <InfoOutlinedIcon></InfoOutlinedIcon>
                          </Tooltip>{" "}
                        </p>
                        <SelectReport
                          options={countrylistoptions}
                          action="Descargar el análisis de las cifras del conflicto en"
                        ></SelectReport>
                      </>
                    </Fade>
                  </div>
                </div>
              </Container>
            </>
            <HeroVideos
              imageUrl={Quote8}
              id="quote-8"
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.8"
              copyright=""
            >
              <Container>
                <Title h4="Launch of GRID 2022"></Title>
                <div className=" row">
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="Dtim9Jbt_M0" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: high-level segment
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="i0YBwn8XgMY" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: technical segment
                    </p>
                  </div>
                  <div className="col-md-4">
                    <YouTubeVideo youtubeId="BlOm0h7i_jI" />
                    <p style={{ color: "#ffffff" }}>
                      Launch of GRID 2022: technical segment
                    </p>
                  </div>
                </div>
              </Container>
            </HeroVideos>
            <Container
              maxWidth={false}
              className="py-3"
              style={{ backgroundColor: "#dee2e6" }}
            >
              <Container id="mediapack" maxWidth="lg" className="my-3">
                <Title h4="Dosier de prensa"></Title>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Descargar la Nota de Prensa</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>
                      {" "}
                      <PictureAsPdfIconOutlined>
                        {" "}
                      </PictureAsPdfIconOutlined>{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ARA.pdf
"
                      >
                        Árabe
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_EN.pdf
"
                      >
                        Inglés
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_FR.pdf
"
                      >
                        Francés
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_DE.pdf
"
                      >
                        Alemán
                      </a>{" "}
                      |{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_NOR.pdf
"
                      >
                        Noruego
                      </a>{" "}|{' '}
<a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_Russian.pdf
'>Russian</a> 
                      {" "}|{" "}
                      <a
                        href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ES.pdf
"
                      >
                        Español
                      </a>{" "}
                      |{" "}
                      <a href="https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_SWE.pdf">
                        Sueco
                      </a>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Biografía de los portavoces</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <div className="col-md-4">
                        <ShowModal
                          img={Alexandra}
                          name="Alexandra Bilak"
                          title="Directora del Observatorio de Desplazamiento Interno"
                        >
                          <p>
                            Alexandra Bilak trabaja desde hace casi 20 años en
                            el sector de las organizaciones internacionales sin
                            ánimo de lucro, centrada en la investigación y el
                            desarrollo de políticas sobre el desplazamiento en
                            el contexto de los conflictos armados, la violencia,
                            los desastres y el cambio climático. Se incorporó al
                            Observatorio de Desplazamiento Interno en Ginebra
                            como jefa de Política e Investigación en 2014, para
                            dirigir la primera publicación del informe principal
                            del IDMC, el Informe Mundial sobre Desplazamiento
                            Interno (GRID), y es directora de este organismo
                            desde agosto de 2016.
                          </p>
                          <p>
                            Antes de unirse al IDMC, Alexandra pasó una década
                            trabajando en África subsahariana para ONG
                            internacionales e institutos de investigación, como
                            Oxfam, Life & Peace Institute, el Comité
                            Internacional de Rescate y el Consejo Danés para
                            Refugiados. Vivió y trabajó en Ruanda en 2001, en la
                            República Democrática del Congo de 2004 a 2008 y en
                            Kenia de 2009 a 2014. Es autora de numerosas
                            publicaciones sobre el desplazamiento forzado, el
                            conflicto y el desarrollo de la sociedad civil.
                          </p>
                          <p>
                            Alexandra tiene un máster en Política Internacional
                            por la Escuela de Estudios Orientales y Africanos de
                            Londres y un DEA (Diplôme d'Études Approfondies) en
                            Estudios Africanos y Ciencias Políticas por la
                            Universidad de París I Panteón-Sorbona. Es bilingüe
                            de inglés y francés.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Jan}
                          name="Jan Engeland"
                          title="Secretario general del Consejo Noruego para Refugiados"
                          id="jan"
                        >
                          <p>
                            Jan Egeland ocupa el puesto de secretario general
                            del Consejo Noruego para Refugiados (NRC). En
                            septiembre de 2015, el Secretario General de la ONU
                            nombró a Egeland Asesor Especial del Enviado
                            Especial de la ONU para Siria, para centrarse en el
                            acceso humanitario y la protección de los civiles.
                            Dejó este cargo en diciembre de 2018.
                          </p>
                          <p>
                            Entre 2003 y 2006, Egeland fue Secretario General
                            Adjunto de Asuntos Humanitarios y Coordinador del
                            Socorro de Emergencia de la ONU. Antes de ocupar su
                            puesto en el NRC en 2013, Egeland desempeñó el cargo
                            de director para Europa de Human Rights Watch
                            (2011-2013), y anteriormente había sido director
                            ejecutivo del Instituto Noruego de Asuntos
                            Internacionales (2007-2011).
                          </p>
                          <p>
                            Además, fue Asesor Especial del Secretario General
                            de la ONU para Colombia (1999−2001) y secretario de
                            estado del Ministerio de Asuntos Exteriores de
                            Noruega (1990−1997). En 2006, la revista Time nombró
                            a Egeland como una de las «100 personas más
                            influyentes del mundo».
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Bina}
                          name="Bina Desai"
                          title="Jefa de Política e Investigación del IDMC "
                          id="bina"
                        >
                          <p>
                            Bina goza de una amplia experiencia en programas e
                            investigación sobre el desarrollo socioeconómico en
                            países de ingreso bajo. Después de haber trabajado
                            en Bangladesh, Ghana, Honduras, India, Kenia,
                            Malawi, Mozambique y Filipinas, sus intereses de
                            investigación incluyen las causas estructurales de
                            las crisis, las repercusiones económicas y de
                            desarrollo de los desastres y los conflictos, el
                            desplazamiento interno y la migración forzosa.
                          </p>
                          <p>
                            Ha trabajado para el Ministerio de Desarrollo
                            alemán, la Aga Khan Development Network, Christian
                            Aid y la Oficina de las Naciones Unidas para la
                            Reducción del Riesgo de Desastres (UNDDR).
                          </p>
                          <p>
                            En 2017, Bina se unió al IDMC como jefa de Política
                            e Investigación, donde dirige el equipo de asesores
                            e investigadores principales del IDMC en el análisis
                            de políticas relacionadas con el desplazamiento y la
                            recabación de pruebas. Bina cuenta con un máster en
                            Economía y Sociología por la Universidad de
                            Bielefeld y un doctorado en Antropología Social por
                            la Escuela de Estudios Orientales y Africanos de
                            Londres.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Vicente}
                          name="Vicente Anzellini"
                          title="Coordinador del GRID en el IDMC "
                          id="vicente"
                        >
                          <p>
                            Vicente dirige el equipo de análisis global y
                            regional del IDMC y coordina la producción del
                            Informe Mundial sobre Desplazamiento Interno (GRID),
                            para lo que trabaja estrechamente con todos los
                            departamentos para la elaboración del informe
                            principal del IDMC sobre desplazamiento interno.
                          </p>
                          Anteriormente trabajó en la UNDDR, donde realizó un
                          ejercicio de revisión de la política global que sentó
                          la base de los indicadores de la política nacional
                          para el Marco de Sendái, así como en la coordinación
                          de la investigación y los programas nacionales, en el
                          desarrollo de datos y análisis de pérdidas y daños por
                          desastres, y en el desarrollo de la capacitación
                          gubernamental sobre el conocimiento del riesgo a nivel
                          nacional y regional. Ha trabajado en numerosos países
                          de África, Asia central y meridional y el Pacífico.
                          <p>
                            Vicente es licenciado en Historia y Geografía por la
                            Universidad de los Andes (Bogotá, Colombia) y tiene
                            un máster en Geografía Humana y Estudios Migratorios
                            por la Universidad de Neuchâtel (Suiza). Habla
                            español, francés e inglés.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Vincent}
                          name="Vincent Fung"
                          title="Coordinador regional de Asia y Pacífico"
                          id="vincent"
                        >
                          <p>
                            Vincent es coordinador regional del IDMC y se dedica
                            al monitoreo y a la investigación del desplazamiento
                            en la región de Asia y el Pacífico. Vincent se
                            incorporó al IDMC en 2016 en calidad de experto en
                            monitoreo para el Departamento de Datos y Análisis.
                          </p>
                          <p>
                            Con más de 15 años de experiencia en consultoría de
                            análisis de datos, gestión de la información y
                            comunicación visual, Vincent ha colaborado en temas
                            que van desde la salud pública, cuestiones urbanas,
                            respuestas humanitarias, hasta la reducción del
                            riesgo de desastres. Es una eminencia de los datos y
                            las comunicaciones digitales, ha trabajado como
                            formador y diseñador para la ONU en Suiza, como
                            asesor de gestión de la información para el
                            Coordinador de Asuntos Humanos en Timor-Leste, y
                            también ha brindado su experiencia en análisis
                            espacial y cartografía a la OCHA en la región de
                            Asia y el Pacífico. Además, Vincent ha sido
                            consultor en proyectos similares para la PNUD en el
                            sudeste asiático, ONG sanitarias en los Balcanes y
                            gobiernos locales y federales en Canadá.
                          </p>
                          <p>
                            Vincent es geógrafo de formación y tiene un máster
                            en Gestión Internacional Urbana y Medioambiental por
                            la Universidad RMIT, especializado en estudios de
                            comportamiento. Habla inglés, francés y cantonés y
                            tiene nociones de japonés y tailandés.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Ivana}
                          name="Ivana Hajzmanova"
                          title="Coordinadora regional para MENA y África Subsahariana"
                          id="ivana"
                        >
                          <p>
                            Ivana es coordinadora regional del IDMC, donde se
                            dedica al monitoreo e investigación de los
                            desplazamientos en Oriente Medio y África. Se
                            incorporó al IDMC en 2016, para aportar su
                            experiencia en el análisis de necesidades
                            humanitarias y conflictos. Ivana se ha formado en
                            derecho humanitario y derechos humanos, y
                            previamente se dedicó al análisis y la evaluación de
                            las necesidades humanitarias, y a la defensa de los
                            derechos humanos con ONG nacionales e
                            internacionales.
                          </p>
                          <p>
                            Cuenta con un máster en Derechos Humanos y Acción
                            Humanitaria por el Instituto de Estudios Políticos
                            de París, e hizo una estancia de un semestre para
                            estudiar derecho internacional e historia de la
                            violencia en el Instituto Universitario de Altos
                            Estudios Internacionales de Ginebra.
                          </p>
                          <p>
                            Ivana habla con fluidez inglés, francés, español y
                            checo. Además, puede comunicarse en árabe.
                          </p>
                        </ShowModal>
                      </div>
                      <div className="col-md-4">
                        <ShowModal
                          img={Ricardo}
                          name="Ricardo Fal-Dutra Santos"
                          title="Coordinador regional de América, Europa, Cáucaso y Asia central"
                          id="ricardo"
                        >
                          <p>
                            Ricardo Fal-Dutra Santos se unió a nosotros como
                            coordinador regional para América, Europa, Cáucaso y
                            Asia central. Cuenta con más de siete años de
                            experiencia en la dirección de investigaciones y
                            respuestas humanitarias, en concreto en el ámbito de
                            la protección, en Angola, Jordania, Mozambique,
                            Nigeria, Palestina, Sudáfrica y Sudán del Sur.
                            Asimismo, ha trabajado en las sedes del Comité
                            Internacional de la Cruz Roja y de Oxfam, prestando
                            apoyo a los equipos nacionales en varios países.
                          </p>
                          <p>
                            Ricardo tiene un máster en Seguridad Internacional
                            por el Instituto de Estudios Políticos de París
                            (París, Francia) y una licenciatura en Historia por
                            la Universidad Federal Fluminense (Niterói, Brasil).
                            Habla inglés, francés, portugués y español.
                          </p>
                        </ShowModal>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography> Fotos de prensa/B-Roll</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>
                      <a href="https://www.internal-displacement.org/sites/default/files/grid2022-broll.zip">
                        B-roll (Zip folder | 578Mb)
                      </a>
                    </p>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <Typography> Infografías</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="row">
                      <ShowModalInfog
                        img={map_global_dld}
                        id="infographic-globalmap"
                        name="Global map"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={SpiralDld}
                        id="infographic-spiral"
                        name="Spiral"
                      ></ShowModalInfog>

                      <ShowModalInfog
                        img={BreakddownDld}
                        id="infographic-breakdown"
                        name="breakdown"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_conflict_dld}
                        id="infographic-map-conflict"
                        name="Map - conflict"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_disasters_dld}
                        id="infographic-map-disasters"
                        name="Map - disasters"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={map_youth_dld}
                        id="infographic-map-youth"
                        name="Map - youth"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={read_data_conflict}
                        id="read_data_conflict"
                        name="How to read data - conflict and violence"
                      ></ShowModalInfog>
                      <ShowModalInfog
                        img={read_data_disasters}
                        id="read_data_disasters"
                        name="How to read data - disasters"
                      ></ShowModalInfog>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </Container>
            </Container>

            <Footer
              imageUrl={gridhero}
              txtColor="#ffffff"
              bgColor="#0a3758"
              bgOpacity="0.3"
            />
          </div>
        </div>
      </main>
    </>
  );
  //const launchTime = new Date(Date.UTC(2022, 4, 19, 4, 0, 0));
  //const launchTime = new Date(Date.UTC(2022, 4, 18, 10, 27, 0));
  // const timeNow = new Date();
  // let isTest = false
  // if (typeof window !== 'undefined'){
  // const queryParams = new URLSearchParams(window.location.search)
  //  isTest = queryParams.get("test")}

  // const formattedDate= date =>{

  //   if (launchTime <= timeNow || isTest ){
  //   return indexContent} else {
  //   return comingsoonContent }
  // }
  //return formattedDate(launchTime)
};

// export const query = graphql`
//   query {
//     part1: mdx(slug: { eq: "english-part1" }) {
//       frontmatter {
//         h2
//         h3
//         graph1_caption
//       }
//     }
//     general: mdx(slug: { eq: "generic-english" }) {
//       frontmatter {
//         interact
//         download
//       }
//     }
//   }
// `

export default IndexPageDev;
